// extracted by mini-css-extract-plugin
module.exports = {"switchRoot":"Toggle_switchRoot__ax614","switchThumb":"Toggle_switchThumb__32MoW"};